import React from 'react';
import { Spin, Icon } from 'antd';

const antIcon = <Icon type="loading" style={{ fontSize: 35 }} spin />;

const Loading = () => {
  return <Spin indicator={antIcon} />;
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js